import { sleep } from '@/utils/sleep'
import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useToast = defineStore('toast', () => {
	const list = ref<
		{
			id: number
			text: string
			type: 'info' | 'error' | 'success'
			duration: number
			action?: {
				text: string
				onClick: () => void
			}
		}[]
	>([])

	const add = (toast: {
		text: string
		type: 'info' | 'error' | 'success'
		duration?: number
		action?: {
			text: string
			onClick: () => void
		}
	}) => {
		const duration = toast.duration || 3000
		const id = Date.now()

		list.value.unshift({ ...toast, duration, id })

		if (duration > 0) {
			removeAfterDuration(id, duration)
		}

		return id
	}

	const removeAfterDuration = async (id: number, duration: number) => {
		await sleep(duration)
		remove(id)
	}

	const remove = (id: number) => {
		list.value = list.value.filter((toast) => toast.id !== id)
	}

	const replaceOrAdd = (toast: {
		id?: number
		text: string
		type: 'info' | 'error' | 'success'
		duration?: number
		action?: {
			text: string
			onClick: () => void
		}
	}) => {
		if (!toast.id) {
			return add(toast)
		}

		const index = list.value.findIndex((t) => t.id === toast.id)

		if (index === -1) {
			return add(toast)
		}

		const duration = toast.duration || 3000

		list.value[index] = { ...list.value[index], ...toast }

		if (duration > 0) {
			removeAfterDuration(toast.id, duration)
		}

		return toast.id
	}

	return {
		list,
		add,
		remove,
		replaceOrAdd
	}
})
